import { render, staticRenderFns } from "./dropdownWrapper.vue?vue&type=template&id=587c1c1c&"
import script from "./dropdownWrapper.vue?vue&type=script&lang=js&"
export * from "./dropdownWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/common/dropdownWrapper.vue"
export default component.exports